import React, {Component} from 'react';
import {connect} from 'react-redux';
import {find} from 'lodash';
import {Field} from 'redux-form';
import {Table, Loader, Icon, Modal, Popup} from 'semantic-ui-react';
import {ordersStatus, tasksStatus} from '../../../common/dictionaries/accessories';
import {toFloat, toInteger} from '../../../common/util/fieldsNormalization';
import {InputField, DropdownField} from '../../../common/components/form';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {outsourcedOptions, responsibleOptions} from '../../constants';
import {Actions} from '../../../common/actions';
import './tasks.scss';


class TasksAssignmentTableItems extends Component {
  checkRequiredField(value) {
    return value ? null : 'Required';
  }

  getTechniciansOptions() {
    return this.props.techniciansList.map((item) => {
      return {
        'text': `${item.technician} - ${item.name}`,
        'value': item.technician,
      };
    });
  }

  getTasksOptions() {
    return this.props.availableTasksList.map((item) => {
      return {
        'text': `${item.serviceCode3} - ${item.description}`,
        'value': item.serviceCode3,
      };
    });
  }

  getTaskInfo(serviceCode3) {
    const {availableTasksList} = this.props;
    const taskInfo = find(availableTasksList, {'serviceCode3': serviceCode3});
    return taskInfo || {};
  }

  saveTaskInfo({index, element}, event, technicianId) {
    if (!technicianId) {
      return;
    }
    const newElement = {...element};
    newElement.technician = technicianId;
    delete newElement.totalPrice;
    this.props.saveOrDeleteItem(index, 'add', newElement);
  }

  openOutsourcedModal(index, event, type) {
    if (!type || type !== 'S') {
      return;
    }

    this.props.handleState({
      'modalWasOpen': true,
      index,
    });
  }

  onDeleteClick(index, element) {
    this.props.saveOrDeleteItem(index, 'delete', element);
  }

  updateTotalValues(index, quantity, unitPrice) {
    this.props.updateTotals({index, quantity, unitPrice, 'type': 'task'});
  }

  updateTaskInfo(index, event, serviceCode3) {
    if (!serviceCode3) {
      return;
    }
    const taskInfo = this.getTaskInfo(serviceCode3);
    this.props.addTaskInfo(index, taskInfo);
  }

  updateQuantity(index, e) {
    const quantity = parseInt(e.target.value, 10);
    this.updateTotalValues(index, quantity, null);
  }

  updateUnitPrice(index, e) {
    const unitPrice = e.target.value;
    this.updateTotalValues(index, null, unitPrice);
  }

  renderPartPrice(fields, item, index) {
    const {savingItem} = this.props;
    const element = fields.get(index);
    if (
      (element.outsourced && element.outsourced === 'S') ||
      element.itemSaved
    ) {
      return `$${getNumericValue(element.unitPrice || 0, 2)}`;
    }

    return (
      <Field
        name={`${item}.unitPrice`}
        type='number'
        component={InputField}
        autoComplete='off'
        required
        validate={this.checkRequiredField}
        normalize={toFloat}
        disabled={element.itemSaved || !element.outsourced || savingItem}
        min='1'
        step='0.01'
        onChange={this.updateUnitPrice.bind(this, index)}
        placeholder='Cant.'
        invalidMessage='Por favor, llene este campo'
        props={{'className': 'text-align-right'}}
      />
    );
  }

  renderItems(fields, techniciansOptions, tasksAvailableOptions) {
    const {
      loadingTechnicians,
      loadingAvailableTasks,
      savingItem,
      orderStatus,
    } = this.props;

    return fields.map((item, index) => {
      const element = fields.get(index);

      return (
        <Table.Row key={index} textAlign='center'>
          <Table.Cell className='task-column'>
            {element.itemSaved &&
              `${element.serviceCode3} - ${element.description}`}
            {!element.itemSaved && (
              <Field
                name={`${item}.serviceCode3`}
                options={tasksAvailableOptions}
                component={DropdownField}
                loading={loadingAvailableTasks}
                onChange={this.updateTaskInfo.bind(this, index)}
                placeholder='Tarea'
                required={!element.itemSaved}
                disabled={savingItem}
                search
              />
            )}
          </Table.Cell>
          <Table.Cell>{element.localFlat}</Table.Cell>
          <Table.Cell>
            <Field
              name={`${item}.responsible`}
              component={DropdownField}
              options={responsibleOptions}
              required
              validate={this.checkRequiredField}
              placeholder='Seleccione Responsable'
              disabled={
                element.itemSaved || !element.serviceCode3 || savingItem
              }
              props={{'className': 'text-align-right'}}
            />
          </Table.Cell>
          <Table.Cell className='qty-column'>
            <Field
              name={`${item}.quantity`}
              type='number'
              component={InputField}
              autoComplete='off'
              required
              validate={this.checkRequiredField}
              normalize={toInteger}
              disabled={
                element.itemSaved ||
                !element.serviceCode3 ||
                !element.responsible ||
                savingItem
              }
              min='1'
              step='1'
              onBlur={this.updateQuantity.bind(this, index)}
              placeholder='Cant.'
              invalidMessage='Por favor, llene este campo solo con números enteros mayor a cero'
              props={{'className': 'text-align-right'}}
            />
          </Table.Cell>
          <Table.Cell className='outsourced-column'>
            <Field
              name={`${item}.outsourced`}
              options={outsourcedOptions}
              component={DropdownField}
              onChange={this.openOutsourcedModal.bind(this, index)}
              placeholder='Subcontratado'
              required
              validate={this.checkRequiredField}
              disabled={
                element.itemSaved ||
                !element.serviceCode3 ||
                !element.responsible ||
                !element.quantity ||
                savingItem
              }
            />
          </Table.Cell>
          <Table.Cell textAlign='right'>
            {this.renderPartPrice(fields, item, index)}
          </Table.Cell>
          <Table.Cell textAlign='right'>
            {`$${getNumericValue(element.totalPrice || 0, 2)}`}
          </Table.Cell>
          <Table.Cell className='technician-column'>
            {element.outsourced === 'N' && (
              <Field
                name={`${item}.technician`}
                options={techniciansOptions}
                component={DropdownField}
                loading={loadingTechnicians}
                placeholder='Seleccione Técnico'
                required={element.outsourced === 'N'}
                validate={this.checkRequiredField}
                disabled={
                  element.itemSaved ||
                  !element.serviceCode3 ||
                  !element.outsourced ||
                  savingItem
                }
                onChange={this.saveTaskInfo.bind(this, {index, element})}
                search
              />
            )}
          </Table.Cell>
          <Table.Cell>
            {element.itemSaved && element.outsourced === 'N' && (
              <Icon
                name='circle'
                size='large'
                color={
                  element.status === tasksStatus.finished_task ?
                    'green' :
                    'grey inverted'
                }
              />
            )}
          </Table.Cell>
          {orderStatus && orderStatus === ordersStatus.assigned_technicians && (
            <Table.Cell>
              {element.itemSaved && (
                <Modal
                  size='mini'
                  trigger={
                    <span className='link'>
                      <Popup
                        trigger={
                          <span>
                            <Icon link name='close' color='red' size='large' />
                          </span>
                        }
                        content='Eliminar'
                        position='top center'
                        inverted
                      />
                    </span>
                  }
                  header={`¿Desea eliminar la tarea ${element.serviceCode3}?`}
                  actions={[
                    {'key': 'cancel', 'content': 'Cancelar'},
                    {
                      'key': 'done',
                      'content': 'Confirmar',
                      'positive': true,
                      'onClick': () => this.onDeleteClick(index, element),
                      'primary': true,
                    },
                  ]}
                />
              )}
            </Table.Cell>
          )}
        </Table.Row>
      );
    });
  }

  render() {
    const {tasksLoading, fields} = this.props;

    if (tasksLoading) {
      return (
        <Table.Row className='loader'>
          <Table.Cell colSpan='100%'>
            <Loader active />
          </Table.Cell>
        </Table.Row>
      );
    }

    const techniciansOptions = this.getTechniciansOptions();
    const tasksAvailableOptions = this.getTasksOptions();
    return this.renderItems(fields, techniciansOptions, tasksAvailableOptions);
  }
}

const mapStateToProps = (state) => {
  return {
    'orderStatus': state.form.qualityAssuranceOrders.values.status,
    'loading': state.form.qualityAssuranceOrders.loading,
    'savingItem': state.form.qualityAssuranceOrders.savingItem,
    'loadingTechnicians': state.techniciansAssignment.loading,
    'loadingAvailableTasks': state.tasksAssignmentInQualityAssuranceOrders.loadingTasks,
    'availableTasksList': state.tasksAssignmentInQualityAssuranceOrders.tasksList,
    'techniciansList': state.techniciansAssignment.list,
  };
};

const {
  addTaskInfo,
  updateTotals,
  manageTasksInQualityAssuranceOrder,
} = Actions;

export default connect(mapStateToProps, {
  addTaskInfo,
  updateTotals,
  manageTasksInQualityAssuranceOrder,
})(TasksAssignmentTableItems);
